<template>
  <v-bottom-sheet :value="value" @input="$emit('input', false)" dark inset>
    <v-sheet class="text-left" rounded="t-xl" style="background-color: #1e1e1e">
      <v-toolbar flat color="grey darken-3" class="rounded-t-xl">
        <v-toolbar-title class="font-weight-bold">Reaktionen</v-toolbar-title>
      </v-toolbar>

      <v-tabs v-model="tab" background-color="#272727" grow>
        <v-tab v-for="reaction in reactionGroups" :key="reaction.emoji">
          {{ reaction.emoji }}
          <span class="ml-1" style="font-size: 0.9rem">{{ reaction.count }}</span>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab" style="background-color: transparent; min-height: 250px; max-height: 40vh; overflow-y: auto">
        <v-tab-item v-for="reaction in reactionGroups" :key="reaction.emoji">
          <v-list dark color="transparent">
            <v-list-item v-for="user in reaction.users" :key="user._id" @click="viewProfile(user)">
              <v-list-item-avatar>
                <v-img v-if="user.bild" :src="'/img/profilbilder/' + user.bild"></v-img>
                <span v-else>{{ getInitials(user) }}</span>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>
                  {{ user.vorname }} {{ user.nachname }}
                  <span v-if="user._id === self._id" class="grey--text"> (Du)</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-tab-item>
      </v-tabs-items>

      <v-divider></v-divider>
      <div class="pa-3 d-flex justify-space-around" style="background-color: #272727">
        <v-btn v-for="emoji in quickReactions" :key="emoji" icon @click="onReactionClick(emoji)" :color="didIReactWith(emoji) ? 'primary' : 'grey'">
          <span style="font-size: 1.8rem">{{ emoji }}</span>
        </v-btn>
      </div>
    </v-sheet>
  </v-bottom-sheet>
</template>

<script>
import { mapState, mapActions } from "vuex"

export default {
  name: "ReactionDetailsDialog",
  props: {
    value: Boolean, // v-model
    members: {
      type: Array,
      default: () => [],
    },
    message: {
      // Die VOLLSTÄNDIGE Nachricht
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      tab: 0,
      // (Wir definieren die Quick Reactions hier nochmal)
      quickReactions: ["👍", "❤️", "😂", "🔥", "🙏"],
    }
  },
  created() {
    console.log(this.members, this.message, this.reactionGroups)
  },
  computed: {
    ...mapState("userStore", { self: "user" }), // 'self' statt 'user', um Konflikt zu vermeiden
    reactionGroups() {
      // 1. Prüfen, ob alle Daten da sind
      if (!this.message || !this.message.reactions || !this.members) return []
      const allMembers = this.members
      const groups = {}
      this.message.reactions.forEach((reaction) => {
        // --- HIER IST DER FIX (DEN ICH VERGESSEN HABE) ---
        // Wir überspringen Reaktionen, bei denen der User 'null' ist
        if (!reaction.userId) {
          return // Nächste Reaktion
        } // --- ENDE FIX ---
        // (Dieser Code ist jetzt sicher, weil 'reaction.userId' existiert)
        const reactionUserId = (reaction.userId._id || reaction.userId).toString()

        const memberObject = allMembers.find((m) => m.userId && m.userId._id.toString() === reactionUserId)

        if (memberObject) {
          const user = memberObject.userId
          if (!groups[reaction.emoji]) {
            groups[reaction.emoji] = {
              emoji: reaction.emoji,
              count: 0,
              users: [],
            }
          }
          groups[reaction.emoji].count++
          groups[reaction.emoji].users.push(user)
        }
      })
      return Object.values(groups)
    },
  },
  methods: {
    ...mapActions("chatStore", ["reactToMessage", "viewUserProfile"]),

    getInitials(user) {
      if (!user) return "?"
      const v = user.vorname || ""
      const n = user.nachname || ""
      return `${v.charAt(0).toUpperCase()}${n.charAt(0).toUpperCase()}`
    },

    /**
     * Ruft die Store-Action auf
     */
    onReactionClick(emoji) {
      this.reactToMessage({
        messageId: this.message._id,
        emoji: emoji,
      })
      // (Der Dialog bleibt offen, damit man weiterklicken kann)
    },

    /**
     * Prüft, ob ICH mit diesem Emoji reagiert habe (für die Button-Farbe)
     */
    didIReactWith(emoji) {
      if (!this.message.reactions || !this.self) return false
      return this.message.reactions.some((r) => r.userId && r.userId._id === this.self._id && r.emoji === emoji)
    },
  },
}
</script>
